import { ActionReducer, createReducer, on } from '@ngrx/store';

import {
  AvailableComplianceNotifications,
  AvailableTrainingNotifications,
  NotificationState,
} from './notification.models';
import { NotificationActions } from './notification.actions';
import {
  changeComplianceNotificationStateBasedOnType,
  changeTrainingNotificationStateBasedOnType,
  getTopCompliancePriority,
  getTopTrainingPriority,
} from './notification.helper';

export const initialState: NotificationState = {
  complianceNotificationStatus: {
    expired: {
      active: false,
      name: AvailableComplianceNotifications.expired,
      priority: 0,
    },
    lapsed: {
      active: false,
      name: AvailableComplianceNotifications.lapsed,
      priority: 1,
    },
    dueToExpire: {
      active: false,
      name: AvailableComplianceNotifications.dueToExpire,
      priority: 2,
    },
  },
  topPriorityComplianceNotification: null,
  trainingNotificationStatus: {
    trainingCancelled: {
      active: false,
      name: AvailableTrainingNotifications.trainingCancelled,
      priority: 0,
    },
  },
  topPriorityTrainingNotification: null,
};

export const notificationReducer: ActionReducer<NotificationState> =
  createReducer(
    initialState,
    on(
      NotificationActions.activateComplianceNotification,
      (state, { notificationType }): NotificationState => {
        const complianceNotificationStatus = {
          ...state.complianceNotificationStatus,
          ...changeComplianceNotificationStateBasedOnType(
            state.complianceNotificationStatus,
            notificationType,
            true,
          ),
        };
        const topPriorityComplianceNotification = getTopCompliancePriority(
          complianceNotificationStatus,
        );
        return {
          ...state,
          complianceNotificationStatus,
          topPriorityComplianceNotification,
        };
      },
    ),
    on(
      NotificationActions.activateTrainingNotification,
      (state, { notificationType }): NotificationState => {
        const trainingNotificationStatus = {
          ...state.trainingNotificationStatus,
          ...changeTrainingNotificationStateBasedOnType(
            state.trainingNotificationStatus,
            notificationType,
            true,
          ),
        };
        const topPriorityTrainingNotification = getTopTrainingPriority(
          trainingNotificationStatus,
        );

        return {
          ...state,
          trainingNotificationStatus,
          topPriorityTrainingNotification,
        };
      },
    ),
    on(
      NotificationActions.removeComplianceNotification,
      (state, { notificationType }): NotificationState => {
        const complianceNotificationStatus = {
          ...state.complianceNotificationStatus,
          ...changeComplianceNotificationStateBasedOnType(
            state.complianceNotificationStatus,
            notificationType,
            false,
          ),
        };
        const topPriorityComplianceNotification = getTopCompliancePriority(
          complianceNotificationStatus,
        );

        return {
          ...state,
          complianceNotificationStatus,
          topPriorityComplianceNotification,
        };
      },
    ),
    on(
      NotificationActions.removeTrainingNotification,
      (state, { notificationType }): NotificationState => {
        const trainingNotificationStatus = {
          ...state.trainingNotificationStatus,
          ...changeTrainingNotificationStateBasedOnType(
            state.trainingNotificationStatus,
            notificationType,
            false,
          ),
        };
        const topPriorityTrainingNotification = getTopTrainingPriority(
          trainingNotificationStatus,
        );
        return {
          ...state,
          trainingNotificationStatus,
          topPriorityTrainingNotification,
        };
      },
    ),
    on(
      NotificationActions.clearNotifications,
      (): NotificationState => initialState,
    ),
  );
